/**
 * App routes that stay usable when a campaign's subscription has lapsed. Home and settings let a
 * campaign see where it stands and pay; Work Orders lets any campaign buy, track and download
 * voter data, subscribed or not (ADR-090) — its API is exempt too. Text sends inside it stay gated
 * by the campaign's Work Orders flag, not by the paywall.
 */
const EXEMPT_PREFIXES = ['/app/home', '/app/settings', '/app/work-orders'];

/** Whether `pathname` renders without the paywall overlay. */
export function isPaywallExemptPath(pathname: string): boolean {
  return pathname === '/app' || EXEMPT_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/'),
  );
}

const VOTER_DATA_BUILDER_PATH = /^\/app\/work-orders\/voter-data\/?$/;
const WORK_ORDER_PATH = /^\/app\/work-orders\/([^/]+)\/?$/;

/**
 * Where a path sits for Voter data, which never needs a subscription (ADR-090): the builder, a
 * work order (whose type decides), or neither.
 */
export function voterDataPathKind(
  pathname: string,
): { kind: 'builder' } | { kind: 'workOrder'; id: string } | { kind: 'other' } {
  if (VOTER_DATA_BUILDER_PATH.test(pathname)) return { kind: 'builder' };
  const id = WORK_ORDER_PATH.exec(pathname)?.[1];
  return id ? { kind: 'workOrder', id } : { kind: 'other' };
}
